export const GET_CUSTOMERS = "GET_CUSTOMERS";
export const GET_CUSTOMER_BY_ID = "GET_CUSTOMER_BY_ID";
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const DELETE_CUSTOMER = "DELETE_CUSTOMER";
export const CREATE_CUSTOMER = "CREATE_CUSTOMER";
export const GET_CUSTOMER_USERS = "GET_CUSTOMER_USERS";
export const ADD_CUSTOMER_USER = "ADD_CUSTOMER_USER";
export const DELETE_CUSTOMER_USER = "DELETE_CUSTOMER_USER";
